import { SVGProps } from "react"
const GetFileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 13V16.3333C17.5 16.7754 17.3244 17.1993 17.0118 17.5118C16.6993 17.8244 16.2754 18 15.8333 18H4.16667C3.72464 18 3.30072 17.8244 2.98816 17.5118C2.67559 17.1993 2.5 16.7754 2.5 16.3333V13"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 13V16.3333C17.5 16.7754 17.3244 17.1993 17.0118 17.5118C16.6993 17.8244 16.2754 18 15.8333 18H4.16667C3.72464 18 3.30072 17.8244 2.98816 17.5118C2.67559 17.1993 2.5 16.7754 2.5 16.3333V13"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 13V16.3333C17.5 16.7754 17.3244 17.1993 17.0118 17.5118C16.6993 17.8244 16.2754 18 15.8333 18H4.16667C3.72464 18 3.30072 17.8244 2.98816 17.5118C2.67559 17.1993 2.5 16.7754 2.5 16.3333V13"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 13V16.3333C17.5 16.7754 17.3244 17.1993 17.0118 17.5118C16.6993 17.8244 16.2754 18 15.8333 18H4.16667C3.72464 18 3.30072 17.8244 2.98816 17.5118C2.67559 17.1993 2.5 16.7754 2.5 16.3333V13"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 8.83203L10.0007 12.9987L14.1673 8.83203"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 8.83203L10.0007 12.9987L14.1673 8.83203"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 8.83203L10.0007 12.9987L14.1673 8.83203"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 8.83203L10.0007 12.9987L14.1673 8.83203"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 13V3" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M10 13V3"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13V3"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13V3"
      stroke="black"
      strokeOpacity="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default GetFileIcon
